import ML from './mediaProcessor/ml';

/**
 * Whether the client supports media processors, like video and audio filters.
 *
 * This function has a .promise variant, which is recommended over the static one as it
 * will do a more thorough check of the browser's capabilities, giving a more accurate and
 * futureproof result.
 *
 * <p>
 * The following example enables the background blur filter, if supported
 * by the client:
 * <pre>
 * // Add background blur, if supported
 * if (OT.hasMediaProcessorSupport('video')) {
 *   publisherOptions.videoFilter = {
 *     type: 'backgroundBlur',
 *   };
 * }
 * // Add advanced noise suppression, if supported
 * if (OT.hasMediaProcessorSupport('audio')) {
 *   publisherOptions.audioFilter = {
 *     type: 'advancedNoiseSuppression',
 *   };
 * }
 *
 * const publisher = OT.initPublisher(publisherOptions);
 * </pre>
 *
 * <p>
 * The following example uses the .promise variant:
 * <pre>
 * if (await OT.hasMediaProcessorSupport.promise('video')) {
 *   publisherOptions.videoFilter = {
 *     type: 'backgroundBlur',
 *   };
 * }
 * </pre>
 *
 * @param {String} mediaType 'audio', 'video' or 'both'. Defaults to 'both'
 *
 * @return {Boolean} Whether the client supports media processors (<code>true</code>), like
 * video and audio filters, or not (<code>false</code>).
 *
 * @method OT.hasMediaProcessorSupport
 * @memberof OT
 *
 * @see <a href="#initPublisher">OT.initPublisher()</a>
 * @see <a href="Publisher.html#applyVideoFilter">Publisher.applyVideoFilter()</a>
 * @see <a href="Publisher.html#applyAudioFilter">Publisher.applyAudioFilter()</a>
 */
export default ML.isSupported;
